/* 
 * Export component file to be used on project
*/

import ModalChangeScheduleStatus from "./ModalChangeScheduleStatus";
export default ModalChangeScheduleStatus;
